import { Reducer } from 'redux'

import {
  CONTESTS_FETCH_REQUEST,
  CONTESTS_FETCH_SUCCESS,
} from '../actions/constants'
import { ContestsActions } from '../actions/contests'

export interface IDomande {
  domanda: string
  opzioni?: string[]
  tipo?: 'singolo' | 'multiplo'
}

export interface IContest {
  id_concorso: string
  domande: IDomande[]
  titolo: string
  [key: string]: any
}

export interface IContests {
  fetching: boolean
  data: IContest[]
}

const CONTEST_INITIAL_STATE: IContests = {
  fetching: false,
  data: [],
}

export const contests: Reducer<IContests, ContestsActions> = (
  state = CONTEST_INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case CONTESTS_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      }
    case CONTESTS_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload,
      }
    default:
      return state
  }
}
